module.exports = __webpack_public_path__ + "static/media/2.4f340d6f.jpeg";